(function () {
  'use strict';

  /* ── BOT DOMAIN BLOCKLIST ───────────────────────────────── */
  var BLOCKED = [
    'meta1.in.net', 'pifpaf.space', 'ge-credit.store', 'ge-credit.ru',
    'xrust.club', 'zlot555.com', 'imails.site', 'softdisc.site',
    'vmailer.site', 'cocaine-in-kyiv.online', 'tupop.online',
    'mymailer.buzz', 'filmkachat.ru', 'vykup-auto123.ru', 'adann.xyz',
    'webstor-globalyou.store', 'ui.dogle.info'
  ];
  function isBlocked(email) {
    var parts = email.split('@');
    if (parts.length !== 2) return false;
    var domain = parts[1].toLowerCase();
    for (var i = 0; i < BLOCKED.length; i++) {
      if (domain === BLOCKED[i] || domain.slice(-(BLOCKED[i].length + 1)) === '.' + BLOCKED[i]) return true;
    }
    return false;
  }

  /* ── CONFIG ─────────────────────────────────────────────── */
  var COMPANY_ID   = 'Y9Wa3b';
  var LIST_ID      = 'XmEwJL';
  var CODE         = 'WELCOME10';
  var KEY_DONE     = 'pw_quiz_v1_done';
  var KEY_SEEN     = 'pw_quiz_v1_seen';
  var TRIGGER_MS   = 6000;    // show after 6s on page
  var TRIGGER_PGS  = 2;       // OR after 2 pages in session
  var RESURFACE_MS = 7 * 24 * 60 * 60 * 1000; // re-show after 7 days if dismissed

  /* ── GATES ───────────────────────────────────────────────── */
  if (localStorage.getItem(KEY_DONE)) return;
  var seenAt = localStorage.getItem(KEY_SEEN);
  if (seenAt && Date.now() - parseInt(seenAt) < RESURFACE_MS) return;

  /* ── PAGE-TYPE SUPPRESSION ──────────────────────────────────
     Don't interrupt shoppers who are mid-purchase. Runs on home,
     blog and collection pages; skipped on product/cart/checkout. */
  var path = location.pathname;
  if (/\/products\//.test(path) || /^\/cart/.test(path) || /\/checkouts?(\/|$)/.test(path)) return;
  /* Account/self-service pages (Awtomic subscription portal lives at
     /tools/bundle-subscriptions). A member arriving from a win-back or
     card-update email needs the login field, not a quiz over the top of it. */
  if (/^\/tools\//.test(path) || /^\/account/.test(path) || /^\/apps\/club/.test(path)) return;   // Wine Club page, 2026-09-18

  /* ── PAGE COUNT ─────────────────────────────────────────── */
  var PG_KEY  = 'pw_pgs_v1';
  var pgCount = parseInt(sessionStorage.getItem(PG_KEY) || '0') + 1;
  sessionStorage.setItem(PG_KEY, pgCount);


  /* -- EMAIL TYPO GUARD ------------------------------------
     The validity regex accepts ANY tld, so real people typing ".con" sailed
     straight through and hard-bounced forever: 4 of 296 quiz signups between
     2026-05-25 and 2026-08-18, i.e. 1.4% of all signups lost for want of a
     tld check. We SUGGEST a correction rather than reject, because a hard
     reject loses the signup just as surely. ".co" is a real tld, so it is only
     corrected for domains that provably have no .co variant (see DOMAIN_FIX). */
  var TLD_FIX = {
    con: 'com', cim: 'com', cpm: 'com', vom: 'com', xom: 'com', som: 'com',
    comm: 'com', cmo: 'com', ocm: 'com', copm: 'com', clm: 'com',
    nte: 'net', ner: 'net', bet: 'net', orgg: 'org', orh: 'org'
  };
  var DOMAIN_FIX = {
    'gmial.com': 'gmail.com', 'gmai.com': 'gmail.com', 'gnail.com': 'gmail.com',
    'gmaill.com': 'gmail.com', 'gmail.co': 'gmail.com', 'gamil.com': 'gmail.com',
    'yahooo.com': 'yahoo.com', 'yaho.com': 'yahoo.com', 'yahoo.co': 'yahoo.com',
    'hotmial.com': 'hotmail.com', 'hotmai.com': 'hotmail.com',
    'outlok.com': 'outlook.com', 'iclould.com': 'icloud.com', 'icloud.co': 'icloud.com'
  };
  function suggestEmail(email) {
    var at = email.lastIndexOf('@');
    if (at < 1) return null;
    var local = email.slice(0, at), domain = email.slice(at + 1).toLowerCase();
    if (DOMAIN_FIX[domain]) return local + '@' + DOMAIN_FIX[domain];
    var dot = domain.lastIndexOf('.');
    if (dot < 1) return null;
    var tld = domain.slice(dot + 1);
    if (TLD_FIX[tld]) return local + '@' + domain.slice(0, dot + 1) + TLD_FIX[tld];
    return null;
  }

  /* ── QUIZ DATA ──────────────────────────────────────────── */
  var Q1 = {
    q: "What's your wine world?",
    key: 'wine_style',
    opts: [
      { v: 'classic', l: 'Classic appellations',       s: 'Burgundy, Barolo, Chablis' },
      { v: 'natural', l: 'Natural & low-intervention', s: 'Small producers, living wines' },
      { v: 'both',    l: 'I want to explore both',     s: 'No allegiances, just good wine' }
    ]
  };

  var Q2 = {
    q: 'How do you usually drink?',
    key: 'drinking_occasion',
    opts: [
      { v: 'weeknight',  l: 'Weeknight with dinner',   s: 'Something honest and drinkable' },
      { v: 'occasion',   l: 'Special occasions',       s: 'Worth remembering' },
      { v: 'collection', l: 'Building a small cellar', s: 'Patience is the plan' }
    ]
  };

  var HEADS = {
    'classic-weeknight':   'For the classic wine lover\nat the dinner table.',
    'classic-occasion':    'For the classic wine lover\nwho marks the moment.',
    'classic-collection':  'For the collector\nwho knows what\'s good.',
    'natural-weeknight':   'For the natural wine drinker\nwho drinks well every night.',
    'natural-occasion':    'For the natural wine devotee\nwho celebrates properly.',
    'natural-collection':  'For the natural wine explorer\nbuilding something special.',
    'both-weeknight':      'For the curious drinker\nwho eats well and drinks better.',
    'both-occasion':       'For the one who hasn\'t picked a side\nand doesn\'t need to.',
    'both-collection':     'For the explorer\nwho wants it all.'
  };

  /* ── STATE ──────────────────────────────────────────────── */
  var answers     = {};
  var currentStep = 0;
  var overlay, card, dotsEl, stepLabel, inner, lastFocused;

  /* ── BRAND ASSETS (2026-10-13 redesign, Guido: "completely redone in our new branding") ──
     Wordmark = snippets/pw-wordmark.liquid (Fixel 760 narrow, soft corners), copied as a path so the
     script needs no Liquid. Burst = the
     Today's Pick starburst outline. Icons are Lucide (x, arrow-right, check, copy). */
  var WORDMARK = '<svg class="pw-wm" viewBox="63 -747 5030 759" role="img" aria-label="Primal Wine" focusable="false"><path fill="currentColor" d="M301.8 -700H77.3Q70.8 -700 67.2 -695Q62.6 -691 62.6 -684V-16Q62.6 -9 67.2 -5Q70.8 0 77.3 0H206.1Q212.5 0 216.2 -5Q220.8 -9 220.8 -16V-183Q220.8 -197 230 -206Q238.3 -216 251.2 -216H301.8Q355.1 -216 399.3 -233Q443.4 -250 474.7 -281Q506 -312 522.6 -356Q540 -400 540 -454V-465Q540 -518 522.6 -562Q506 -605 474.7 -636Q443.4 -667 399.3 -684Q356 -700 301.8 -700ZM216.2 -381V-520Q216.2 -534 225.4 -544Q234.6 -554 247.5 -554H286.1Q308.2 -554 326.6 -548Q345 -541 357.9 -530Q370.8 -518 377.2 -500Q384.6 -483 384.6 -461V-451Q384.6 -428 377.2 -410Q369.8 -391 357 -378Q343.2 -364 323.8 -356Q304.5 -349 282.4 -349H245.6Q233.7 -349 224.5 -358Q216.2 -368 216.2 -381ZM713 -520H622.8Q616.4 -520 612.7 -515Q608.1 -511 608.1 -504V-16Q608.1 -9 612.7 -5Q616.4 0 622.8 0H744.3Q750.7 0 754.4 -5Q759 -9 759 -16V-273Q759 -296 766.4 -315Q772.8 -334 785.7 -346Q798.6 -359 817.9 -366Q836.3 -373 859.3 -373Q869.4 -373 880.4 -372Q886.9 -371 892.4 -370Q895.2 -369 897.9 -371Q900.7 -373 900.7 -377V-513Q900.7 -520 894.2 -520H886.9Q841.8 -520 805 -500Q775.6 -485 751.6 -459Q748.9 -456 744.3 -457Q740.6 -459 739.7 -464Q738.8 -473 736.9 -484Q734.2 -495 732.3 -505Q730.5 -512 725 -516Q719.4 -520 713 -520ZM1096.6 -520H975.2Q968.8 -520 965.1 -515Q960.5 -511 960.5 -504V-16Q960.5 -9 965.1 -5Q968.8 0 975.2 0H1096.6Q1103.1 0 1106.8 -5Q1111.4 -9 1111.4 -16V-504Q1111.4 -511 1106.8 -515Q1103.1 -520 1096.6 -520ZM1035 -584Q1073.6 -584 1097.6 -606Q1121.5 -628 1121.5 -665Q1121.5 -702 1097.6 -724Q1073.6 -747 1035 -747Q997.3 -747 974.3 -724Q951.3 -702 951.3 -665Q951.3 -628 974.3 -606Q997.3 -584 1035 -584ZM1311 -520H1220.8Q1214.4 -520 1210.7 -515Q1206.1 -511 1206.1 -504V-16Q1206.1 -9 1210.7 -5Q1214.4 0 1220.8 0H1342.3Q1348.7 0 1352.4 -5Q1357 -9 1357 -16V-286Q1357 -313 1361.6 -334Q1367.1 -354 1377.2 -368Q1387.4 -382 1401.2 -389Q1415 -396 1432.4 -396H1434.3Q1449.9 -396 1461 -391Q1472.9 -386 1480.3 -376Q1487.6 -365 1491.3 -348Q1495 -330 1495 -305V-16Q1495 -9 1499.6 -5Q1503.3 0 1509.7 0H1631.2Q1637.6 0 1641.3 -5Q1645.9 -9 1645.9 -16V-286Q1645.9 -314 1650.5 -334Q1656 -355 1666.1 -368Q1676.2 -382 1691 -390Q1704.8 -397 1721.3 -397H1723.2Q1739.7 -397 1750.8 -392Q1761.8 -388 1769.2 -377Q1776.5 -366 1780.2 -348Q1783.9 -331 1783.9 -306V-17Q1783.9 -10 1788.5 -6Q1792.2 -1 1798.6 -1H1920Q1926.5 -1 1930.2 -6Q1934.8 -10 1934.8 -17V-335Q1934.8 -430 1895.2 -481Q1856.6 -532 1784.8 -532H1781.1Q1734.2 -532 1694.6 -508Q1663.4 -490 1638.5 -460Q1633.9 -455 1627.5 -456Q1621 -457 1617.4 -463Q1600.8 -492 1575 -510Q1541.9 -532 1494.1 -532H1491.3Q1445.3 -532 1406.7 -510Q1374.5 -491 1349.6 -460Q1346.9 -457 1342.3 -458Q1337.7 -459 1337.7 -464Q1335.8 -474 1334 -485Q1332.2 -496 1330.3 -505Q1328.5 -512 1323 -516Q1317.4 -520 1311 -520ZM2292.6 -334V-327Q2292.6 -322 2288 -322H2259.5Q2122.4 -322 2058 -280Q1992.7 -238 1992.7 -154V-142Q1992.7 -107 2004.7 -78Q2015.7 -50 2037.8 -30Q2059 -10 2087.5 1Q2116.9 12 2151.9 12Q2197 12 2234.7 -6Q2266.9 -22 2289 -47Q2291.7 -50 2295.4 -49Q2299.1 -48 2300 -44Q2301.8 -35 2302.8 -26Q2304.6 -19 2307.4 -12Q2310.1 0 2323 0H2435.2Q2440.8 0 2444.4 -5Q2448.1 -10 2447.2 -16Q2442.6 -39 2438.9 -62Q2433.4 -92 2433.4 -125V-326Q2433.4 -375 2419.6 -413Q2405.8 -451 2380 -478Q2354.3 -505 2317.5 -518Q2279.8 -532 2233.8 -532H2223.6Q2168.4 -532 2113.2 -515Q2066.3 -500 2027.7 -476Q2022.2 -473 2020.3 -466Q2018.5 -460 2022.2 -454L2063.6 -372Q2066.3 -366 2072.8 -365Q2078.3 -363 2083.8 -366Q2115.1 -386 2144.5 -396Q2180.4 -408 2213.5 -408H2217.2Q2255.8 -408 2274.2 -388Q2292.6 -367 2292.6 -334ZM2292.6 -219V-188Q2292.6 -174 2288 -161Q2283.4 -148 2273.3 -139Q2260.4 -128 2245.7 -122Q2220 -109 2193.3 -109Q2180.4 -109 2169.4 -113Q2158.3 -117 2150 -124Q2142.7 -130 2139 -140Q2134.4 -149 2134.4 -160V-165Q2134.4 -198 2166.6 -215Q2199.7 -232 2266 -232H2280.7Q2285.3 -232 2289 -228Q2292.6 -224 2292.6 -219ZM2662.5 -720H2541Q2534.6 -720 2530.9 -715Q2526.3 -711 2526.3 -704V-16Q2526.3 -9 2530.9 -5Q2534.6 0 2541 0H2662.5Q2668.9 0 2672.6 -5Q2677.2 -9 2677.2 -16V-704Q2677.2 -711 2672.6 -715Q2668.9 -720 2662.5 -720ZM3090.3 -700H2959.6Q2954.1 -700 2950.4 -695Q2946.8 -690 2947.7 -684L3076.5 -16Q3077.4 -9 3082.9 -4Q3087.5 0 3094 0H3255.9Q3262.3 0 3267.8 -4Q3272.4 -9 3274.3 -16L3357.1 -409Q3358 -412 3360.8 -412Q3363.5 -412 3364.4 -409L3447.2 -16Q3449.1 -9 3453.7 -4Q3459.2 0 3465.6 0H3627.6Q3634 0 3638.6 -4Q3644.1 -9 3645 -16L3774.8 -684Q3775.7 -690 3772 -695Q3768.3 -700 3762.8 -700H3632.2Q3625.7 -700 3621.1 -696Q3616.5 -691 3614.7 -684L3541.1 -202Q3540.2 -198 3536.5 -198H3535.6Q3531.9 -198 3531 -202L3427.9 -684Q3426.1 -691 3421.5 -696Q3416 -700 3409.5 -700H3312Q3305.6 -700 3300 -696Q3295.4 -691 3293.6 -684L3191.5 -202Q3190.6 -198 3186.9 -198H3186Q3182.3 -198 3181.4 -202L3107.8 -684Q3105.9 -691 3101.3 -696Q3096.7 -700 3090.3 -700ZM3965.2 -520H3843.8Q3837.3 -520 3833.6 -515Q3829 -511 3829 -504V-16Q3829 -9 3833.6 -5Q3837.3 0 3843.8 0H3965.2Q3971.6 0 3975.3 -5Q3979.9 -9 3979.9 -16V-504Q3979.9 -511 3975.3 -515Q3971.6 -520 3965.2 -520ZM3903.6 -584Q3942.2 -584 3966.1 -606Q3990 -628 3990 -665Q3990 -702 3966.1 -724Q3942.2 -747 3903.6 -747Q3865.8 -747 3842.8 -724Q3819.8 -702 3819.8 -665Q3819.8 -628 3842.8 -606Q3865.8 -584 3903.6 -584ZM4179.6 -520H4089.4Q4083 -520 4079.3 -515Q4074.7 -511 4074.7 -504V-16Q4074.7 -9 4079.3 -5Q4083 0 4089.4 0H4210.8Q4217.3 0 4221 -5Q4225.6 -9 4225.6 -16V-277Q4225.6 -304 4232 -326Q4238.4 -348 4250.4 -364Q4261.4 -379 4278 -388Q4295.5 -396 4315.7 -396H4320.3Q4357.1 -396 4374.6 -372Q4392.1 -348 4392.1 -297V-16Q4392.1 -9 4396.7 -5Q4400.4 0 4406.8 0H4528.2Q4534.7 0 4538.4 -5Q4543 -9 4543 -16V-333Q4543 -428 4500.6 -480Q4457.4 -532 4381 -532H4377.4Q4325.8 -532 4282.6 -508Q4246.7 -487 4220 -456Q4216.4 -452 4212.7 -453Q4208.1 -455 4207.2 -460Q4206.2 -470 4203.5 -482Q4200.7 -494 4198 -505Q4197 -512 4191.5 -516Q4186 -520 4179.6 -520ZM4751.8 -218H5077.3Q5084 -218 5087.8 -223Q5092.6 -227 5092.6 -234V-295Q5092.6 -346 5075.4 -390Q5059 -433 5027.4 -464Q4996.6 -496 4954.4 -514Q4912.2 -531 4861.3 -531H4848.8Q4794.1 -531 4748 -512Q4701.9 -492 4669.3 -458Q4636.6 -423 4618.4 -375Q4600.2 -327 4600.2 -269V-250Q4600.2 -191 4618.4 -143Q4636.6 -95 4670.2 -60Q4703.8 -26 4750.9 -7Q4797.9 12 4855.5 12H4871.8Q4899.7 12 4928.5 6Q4957.3 -1 4984.2 -12Q5011 -23 5035 -38Q5051.4 -48 5064.8 -60Q5069.6 -65 5070.6 -72Q5071.5 -78 5067.7 -84L5012 -162Q5009.1 -167 5002.4 -168Q4996.6 -168 4991.8 -164Q4972.6 -146 4947.7 -133Q4915 -116 4874.7 -116H4866.1Q4842.1 -116 4821.9 -123Q4801.8 -130 4787.4 -143Q4773 -156 4764.3 -174Q4754.7 -193 4751.8 -217ZM4943.8 -312H4775.8Q4768.2 -312 4763.4 -318Q4758.6 -324 4760.5 -332Q4764.3 -345 4768.2 -356Q4776.8 -375 4789.3 -388Q4800.8 -401 4816.2 -408Q4832.5 -415 4850.7 -415H4859.4Q4877.6 -415 4893 -408Q4908.3 -402 4919.8 -390Q4931.4 -377 4937.1 -358Q4943.8 -340 4943.8 -316Z"/></svg>';
  var BURST = '<svg class="pw-burst" viewBox="0 0 100 100" aria-hidden="true" focusable="false"><path d="M50.0 1.0 54.6 15.3 62.7 2.7 63.4 17.7 74.5 7.6 71.3 22.2 84.6 15.4 77.8 28.7 92.4 25.5 82.3 36.6 97.3 37.3 84.7 45.4 99.0 50.0 84.7 54.6 97.3 62.7 82.3 63.4 92.4 74.5 77.8 71.3 84.6 84.6 71.3 77.8 74.5 92.4 63.4 82.3 62.7 97.3 54.6 84.7 50.0 99.0 45.4 84.7 37.3 97.3 36.6 82.3 25.5 92.4 28.7 77.8 15.4 84.6 22.2 71.3 7.6 74.5 17.7 63.4 2.7 62.7 15.3 54.6 1.0 50.0 15.3 45.4 2.7 37.3 17.7 36.6 7.6 25.5 22.2 28.7 15.4 15.4 28.7 22.2 25.5 7.6 36.6 17.7 37.3 2.7 45.4 15.3Z" fill="#FF3E00" stroke="#16141A" stroke-width="1" stroke-linejoin="round"/><g transform="rotate(-12 50 50)"><text x="50" y="49" text-anchor="middle" class="pw-burst__big">10%</text><text x="50" y="63" text-anchor="middle" class="pw-burst__small">OFF</text></g></svg>';
  var ICON = {
    x:     '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M18 6 6 18M6 6l12 12" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M5 12h14M13 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    check: '<svg viewBox="0 0 24 24" width="28" height="28" aria-hidden="true" focusable="false"><path d="M20 6 9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    copy:  '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false"><rect x="9" y="9" width="12" height="12" rx="2" fill="none" stroke="currentColor" stroke-width="2"/><path d="M5 15H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>'
  };

  /* ── CSS ────────────────────────────────────────────────── */
  function injectCSS() {
    var s = document.createElement('style');
    var INK = '#16141A', LAV = '#CEB7EF', LAV_PALE = '#EEE6F9', MUTED = '#45414C', MINT = '#A8EFD0';
    var SPRING = 'cubic-bezier(.23,1,.32,1)';
    s.textContent = [
      '#pw-overlay{position:fixed;inset:0;z-index:99999;background:rgba(22,20,26,.6);',
        'backdrop-filter:blur(4px);-webkit-backdrop-filter:blur(4px);',
        'display:flex;align-items:center;justify-content:center;padding:20px;box-sizing:border-box;',
        'opacity:0;transition:opacity .32s ' + SPRING + ';',
        'font-family:"Fixel",-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;font-stretch:87.5%;color:' + INK + ';}',
      '#pw-overlay.pw-on{opacity:1}',
      '#pw-overlay *{box-sizing:border-box}',

      /* card: white, 1px ink edge, real soft depth */
      '#pw-card{background:#fff;width:100%;max-width:480px;max-height:calc(100vh - 40px);overflow:auto;position:relative;',
        'border-radius:22px;border:1px solid ' + INK + ';box-shadow:0 30px 70px -24px rgba(22,20,26,.55),0 10px 24px -12px rgba(22,20,26,.3);',  /* a real border: the masthead painted over the old inset edge */
        'transform:translateY(14px) scale(.95);transition:transform .5s ' + SPRING + ';}',
      '#pw-overlay.pw-on #pw-card{transform:none}',

      /* masthead: flat lavender band, centered wordmark */
      '.pw-mast{position:relative;display:flex;align-items:center;justify-content:center;height:144px;',
        'background-color:' + LAV + ';',
        'border-bottom:1px solid ' + INK + ';border-radius:21px 21px 0 0;}',
      '.pw-wm{display:block;height:40px;width:auto;color:' + INK + '}',
      '#pw-card:focus{outline:none}',
      /* the Inbox chat launcher sits above everything; hide it while the quiz is open */
      'body:has(#pw-overlay) shopify-chat{display:none !important}',
      '#pw-close{position:absolute;top:14px;right:14px;width:36px;height:36px;border-radius:50%;border:0;padding:0;cursor:pointer;',
        'display:grid;place-items:center;background:#fff;color:' + INK + ';box-shadow:inset 0 0 0 1px ' + INK + ';z-index:3;',
        'transition:background-color .16s ease,transform .2s ' + SPRING + ';}',
      '#pw-close:active{transform:scale(.92)}',

      /* the one authored moment: the 10% sticker stamps onto the masthead edge */
      '.pw-burst{position:absolute;left:18px;bottom:-46px;width:104px;height:104px;z-index:2;pointer-events:none;',
        'transform:rotate(-18deg) scale(.4);opacity:0;filter:drop-shadow(0 6px 10px rgba(22,20,26,.22));',
        'transition:transform .6s cubic-bezier(.34,1.56,.64,1) .28s,opacity .2s ease .28s;}',
      '#pw-overlay.pw-on .pw-burst{transform:rotate(-8deg) scale(1);opacity:1}',
      '.pw-burst text{font-family:"Fixel Narrow","Fixel",sans-serif;font-weight:760;fill:' + INK + ';letter-spacing:-.02em}',
      '.pw-burst__big{font-size:21px}',
      '.pw-burst__small{font-size:13px}',

      /* progress: three segments, right-aligned so the sticker owns the left */
      '.pw-prog{display:flex;align-items:center;justify-content:flex-end;gap:10px;padding:18px 24px 0 140px}',
      '.pw-dots{display:flex;gap:6px;flex:1;max-width:180px}',
      '.pw-dot{height:9px;flex:1;border-radius:999px;background:' + LAV_PALE + ';box-shadow:inset 0 0 0 1px rgba(22,20,26,.18);transition:background-color .35s ' + SPRING + '}',
      '.pw-dot.on{background:' + INK + ';box-shadow:none}',
      '.pw-step{font-family:"Server Mono",ui-monospace,monospace;font-size:11px;line-height:14px;height:14px;text-transform:uppercase;letter-spacing:-.02em;color:' + MUTED + ';white-space:nowrap}',

      '.pw-inner{padding:30px 28px 28px;transition:opacity .18s ease,transform .18s ease}',
      '.pw-inner.out{opacity:0;transform:translateY(6px)}',

      /* headings: the site H-tag voice */
      '.pw-q,.pw-head,.pw-shead{font-family:"Fixel Narrow","Fixel",sans-serif;font-weight:760;text-transform:uppercase;letter-spacing:-.025em;',
        'line-height:1.02;color:' + INK + ';margin:0 0 20px;text-wrap:balance;font-size:34px}',
      '.pw-head{white-space:pre-line;font-size:28px;margin-bottom:10px}',
      '.pw-shead{font-size:40px;margin-bottom:8px}',

      /* options: the action-tile build (white face, ink edge, 4px lip, lift, press into the lip) */
      '.pw-opts{display:flex;flex-direction:column;gap:12px;padding-bottom:4px}',
      '.pw-opt{display:grid;grid-template-columns:minmax(0,1fr) 36px;align-items:center;gap:12px;width:100%;text-align:left;cursor:pointer;',
        'background:#fff;border:0;border-radius:14px;padding:14px 14px 14px 18px;font:inherit;color:' + INK + ';',
        'box-shadow:inset 0 0 0 1px ' + INK + ',0 4px 0 ' + INK + ';',
        'transition:transform .56s ' + SPRING + ',box-shadow .56s ' + SPRING + ',background-color .16s ease;-webkit-tap-highlight-color:transparent;}',
      '.pw-ol{display:block;font-size:17px;font-weight:600;line-height:1.25}',
      '.pw-os{display:block;font-size:14px;color:' + MUTED + ';margin-top:3px;line-height:1.35}',
      '.pw-go{width:36px;height:36px;border-radius:50%;display:grid;place-items:center;box-shadow:inset 0 0 0 1px ' + INK + ';background:#fff;transition:background-color .16s ease,transform .3s ' + SPRING + '}',
      '.pw-opt:active{transform:translateY(4px) scale(.985);box-shadow:inset 0 0 0 1px ' + INK + ',0 0 0 ' + INK + ';transition-duration:90ms,90ms,160ms}',

      '.pw-sub{font-size:16px;color:' + MUTED + ';line-height:1.5;margin:0 0 20px}',

      '.pw-input{width:100%;height:54px;border:0;border-radius:14px;padding:0 18px;font:inherit;font-size:16px;color:' + INK + ';background:#fff;',
        'box-shadow:inset 0 0 0 1px ' + INK + ';outline:none;margin:0 0 8px;display:block;transition:box-shadow .16s ease}',
      '.pw-input:focus{box-shadow:inset 0 0 0 2px ' + INK + ',0 0 0 4px ' + LAV + '}',
      '.pw-input::placeholder{color:' + MUTED + '}',
      '.pw-input.err{box-shadow:inset 0 0 0 2px #B42318}',
      '.pw-errmsg{font-size:14px;color:#B42318;margin:0 0 10px;display:none}',
      '.pw-errmsg.on{display:block}',

      /* primary action: the hero CTA build (mint face, ink edge, ink lip) */
      '.pw-btn,.pw-shoplink{display:flex;align-items:center;justify-content:center;gap:10px;width:100%;min-height:56px;margin:10px 0 14px;padding:0 20px;',
        'border:0;border-radius:14px;cursor:pointer;text-decoration:none;font:inherit;font-size:18px;font-weight:600;color:' + INK + ';',
        'background:' + MINT + ';box-shadow:inset 0 0 0 1px ' + INK + ',0 4px 0 ' + INK + ';',
        'transition:transform .56s ' + SPRING + ',box-shadow .56s ' + SPRING + ',background-color .16s ease;-webkit-tap-highlight-color:transparent;}',
      '.pw-btn:active,.pw-shoplink:active{transform:translateY(4px) scale(.985);box-shadow:inset 0 0 0 1px ' + INK + ',0 0 0 ' + INK + ';transition-duration:90ms,90ms,160ms}',
      '.pw-btn:disabled{opacity:.6;cursor:progress}',
      '.pw-shoplink:hover{color:' + INK + '}',
      '.pw-fine{font-size:13px;color:' + MUTED + ';text-align:center;margin:0}',

      /* success */
      '.pw-tick{width:56px;height:56px;border-radius:50%;display:grid;place-items:center;margin:0 0 16px;background:' + MINT + ';color:' + INK + ';box-shadow:inset 0 0 0 1px ' + INK + '}',
      '.pw-ssub{font-size:16px;color:' + MUTED + ';line-height:1.5;margin:0 0 20px}',
      '.pw-codebox{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:14px 14px 14px 20px;margin:0 0 6px;border-radius:14px;',
        'background-color:' + LAV + ';box-shadow:inset 0 0 0 1px ' + INK + '}',
      '.pw-code{font-family:"Server Mono",ui-monospace,monospace;font-size:26px;letter-spacing:.02em;color:' + INK + ';',
        'background:#fff;padding:6px 12px;border-radius:8px;box-shadow:inset 0 0 0 1px ' + INK + '}',
      '.pw-copy{display:inline-flex;align-items:center;gap:8px;height:42px;padding:0 16px;border:0;border-radius:12px;cursor:pointer;font:inherit;font-size:15px;font-weight:600;',
        'color:' + INK + ';background:#fff;box-shadow:inset 0 0 0 1px ' + INK + ',0 3px 0 ' + INK + ';transition:transform .4s ' + SPRING + ',box-shadow .4s ' + SPRING + ',background-color .16s ease}',
      '.pw-copy:active{transform:translateY(3px);box-shadow:inset 0 0 0 1px ' + INK + ',0 0 0 ' + INK + ';transition-duration:90ms}',

      '@media (hover:hover) and (pointer:fine){',
        '#pw-close:hover{background:' + LAV_PALE + '}',
        '.pw-opt:hover{background:' + LAV_PALE + ';transform:translateY(-2px);box-shadow:inset 0 0 0 1px ' + INK + ',0 6px 0 ' + INK + '}',
        '.pw-opt:hover .pw-go{background:' + INK + ';color:#fff;transform:translateX(2px)}',
        '.pw-btn:not(:disabled):hover,.pw-shoplink:hover{background:#98F5AB;transform:translateY(-2px);box-shadow:inset 0 0 0 1px ' + INK + ',0 6px 0 ' + INK + '}',
        '.pw-copy:hover{background:' + LAV_PALE + '}',
      '}',

      '.pw-opt:focus-visible,.pw-btn:focus-visible,.pw-copy:focus-visible,.pw-shoplink:focus-visible,#pw-close:focus-visible{outline:3px solid ' + INK + ';outline-offset:3px}',
      '.pw-sr{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}',

      /* phone: bottom sheet */
      '@media (max-width:520px){',
        '#pw-overlay{align-items:flex-end;padding:0}',
        '#pw-card{max-width:100%;max-height:calc(100dvh - 24px);border-radius:22px 22px 0 0;transform:translateY(40px)}',
        '.pw-mast{height:112px}',
        '.pw-wm{height:30px}',
        '.pw-burst{width:84px;height:84px;left:14px;bottom:-38px}',
        '.pw-prog{padding:16px 20px 0 112px}',
        '.pw-inner{padding:26px 20px calc(24px + env(safe-area-inset-bottom,0px))}',
        '.pw-q{font-size:28px}',
        '.pw-head{font-size:24px}',
        '.pw-shead{font-size:34px}',
        '.pw-ol{font-size:16px}',
        '.pw-os{font-size:13.5px}',
        '.pw-code{font-size:22px}',
      '}',

      '@media (prefers-reduced-motion:reduce){',
        '#pw-overlay,#pw-card,.pw-inner,.pw-dot,.pw-opt,.pw-btn,.pw-shoplink,.pw-copy,.pw-go,.pw-burst{transition:none !important}',
        '#pw-card{transform:none}',
        '.pw-burst{transform:rotate(-8deg);opacity:1}',
        '.pw-opt:hover,.pw-opt:active,.pw-btn:hover,.pw-btn:active,.pw-shoplink:hover,.pw-shoplink:active{transform:none}',
      '}'
    ].join('');
    document.head.appendChild(s);
  }

  /* ── BUILD ──────────────────────────────────────────────── */
  function build() {
    lastFocused = document.activeElement;
    overlay = el('div', { id: 'pw-overlay', role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Find your wine style, get 10% off' });
    card    = el('div', { id: 'pw-card', tabindex: '-1' });

    var mast = el('div', { className: 'pw-mast' });
    mast.innerHTML = WORDMARK + BURST;
    card.appendChild(mast);

    var closeBtn = el('button', { id: 'pw-close', type: 'button', 'aria-label': 'Close' });
    closeBtn.innerHTML = ICON.x;
    closeBtn.addEventListener('click', dismiss);
    mast.appendChild(closeBtn);

    var prog = el('div', { className: 'pw-prog' });
    dotsEl = el('div', { className: 'pw-dots', 'aria-hidden': 'true' });
    stepLabel = el('span', { className: 'pw-step', 'aria-live': 'polite' });
    prog.appendChild(dotsEl);
    prog.appendChild(stepLabel);
    card.appendChild(prog);

    inner = el('div', { className: 'pw-inner' });
    card.appendChild(inner);

    overlay.appendChild(card);
    /* click on the dimmed backdrop closes, like Escape */
    overlay.addEventListener('click', function (e) { if (e.target === overlay) dismiss(); });
    document.body.appendChild(overlay);
    setBackgroundInert(true);

    document.addEventListener('keydown', onKeydown, true);

    lockHeight();
    renderStep(0);
    /* first open: focus the dialog itself (no ring on an option the visitor has not chosen); Tab reaches the options */
    try { card.focus({ preventScroll: true }); } catch (e) { card.focus(); }
    raf(function () { raf(function () { overlay.classList.add('pw-on'); }); });
  }

  /* ── FOCUS MANAGEMENT ───────────────────────────────────── */
  /* The page behind the quiz leaves the accessibility tree and the Tab order while the quiz is open
     (aria-modal alone does not hide it in every screen reader). Only elements this script made inert
     are restored, so the age gate's own inert handling is left alone. */
  var madeInert = [];
  function setBackgroundInert(on) {
    if (on) {
      Array.prototype.forEach.call(document.body.children, function (n) {
        if (n === overlay || n.inert || n.tagName === 'SCRIPT') return;
        n.inert = true; madeInert.push(n);
      });
    } else {
      madeInert.forEach(function (n) { n.inert = false; });
      madeInert = [];
    }
  }

  function focusFirst() {
    var f = inner.querySelector('button, [href], input, select, textarea');
    if (f) f.focus();
  }

  function focusables() {
    var nodes = overlay.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    return Array.prototype.filter.call(nodes, function (n) {
      return !n.disabled && n.offsetParent !== null;
    });
  }

  function onKeydown(e) {
    if (e.key === 'Escape') { e.preventDefault(); dismiss(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ── STEP RENDERING ─────────────────────────────────────── */
  function renderStep(n) {
    currentStep = n;
    updateDots(n);
    if (n === 0)      renderQ(Q1);
    else if (n === 1) renderQ(Q2);
    else              renderEmail();
  }

  function updateDots(active, done) {
    dotsEl.innerHTML = '';
    for (var i = 0; i < 3; i++) {
      dotsEl.appendChild(el('div', { className: 'pw-dot' + (i <= active ? ' on' : '') }));
    }
    stepLabel.textContent = done ? 'Done' : 'Step ' + (active + 1) + ' of 3';
  }

  /* One height for every step (Guido 10-13: "height should not change based on content"). Render each step once, out of
     sight, keep the tallest, and pin the content area to it. The email step is measured with the longest personalized heading. */
  var measuring = false;
  function lockHeight() {
    measuring = true;
    inner.style.visibility = 'hidden';
    inner.style.minHeight = '';
    var longest = Object.keys(HEADS).reduce(function (a, k) { return HEADS[k].length > HEADS[a].length ? k : a; });
    var parts = longest.split('-');
    answers = { wine_style: parts[0], drinking_occasion: parts[1] };
    var max = 0;
    [function () { renderQ(Q1); }, function () { renderQ(Q2); }, renderEmail, renderSuccess].forEach(function (fn) {
      fn(); max = Math.max(max, inner.offsetHeight);
    });
    answers = {};
    inner.style.minHeight = max + 'px';
    inner.style.visibility = '';
    measuring = false;
  }

  function fade(fn) {
    inner.classList.add('out');
    setTimeout(function () { fn(); inner.classList.remove('out'); }, 180);
  }

  function renderQ(q) {
    inner.innerHTML = '';

    var qEl = el('h2', { className: 'pw-q', id: 'pw-qh' });
    qEl.textContent = q.q;
    inner.appendChild(qEl);

    var opts = el('div', { className: 'pw-opts', role: 'group', 'aria-labelledby': 'pw-qh' });
    q.opts.forEach(function (o) {
      var btn = el('button', { type: 'button', className: 'pw-opt' });
      var text = el('span', {});
      var label = el('span', { className: 'pw-ol' });
      label.textContent = o.l;
      var sub = el('span', { className: 'pw-os' });
      sub.textContent = o.s;
      text.appendChild(label);
      text.appendChild(sub);
      var go = el('span', { className: 'pw-go' });
      go.innerHTML = ICON.arrow;
      btn.appendChild(text);
      btn.appendChild(go);
      btn.addEventListener('click', function () {
        answers[q.key] = o.v;
        fade(function () { renderStep(currentStep + 1); });
      });
      opts.appendChild(btn);
    });
    inner.appendChild(opts);
    if (currentStep > 0 && !measuring) focusFirst();
  }

  function renderEmail() {
    var key  = answers.wine_style + '-' + answers.drinking_occasion;
    var head = HEADS[key] || 'For the wine lover who knows\nwhat they\'re looking for.';

    inner.innerHTML = '';

    var h = el('h2', { className: 'pw-head' });
    h.textContent = head;
    inner.appendChild(h);

    var s = el('p', { className: 'pw-sub' });
    s.textContent = '10% off your first order, and curated picks in your inbox every week.';
    inner.appendChild(s);

    var input = el('input', { type: 'email', className: 'pw-input', placeholder: 'Your email address', autocomplete: 'email', 'aria-label': 'Email address', 'aria-describedby': 'pw-err' });
    inner.appendChild(input);

    var errMsg = el('p', { className: 'pw-errmsg', id: 'pw-err', role: 'alert' });
    inner.appendChild(errMsg);

    var btn = el('button', { type: 'button', className: 'pw-btn' });
    btn.textContent = 'Claim your 10% off';
    inner.appendChild(btn);

    var fine = el('p', { className: 'pw-fine' });
    fine.textContent = 'No spam. Unsubscribe anytime.';
    inner.appendChild(fine);

    var typoOK = false;
    btn.addEventListener('click', function () {
      var email = input.value.trim();
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || isBlocked(email)) {
        input.classList.add('err');
        input.setAttribute('aria-invalid', 'true');
        errMsg.textContent = 'Please enter a valid email address.';
        errMsg.classList.add('on');
        return;
      }
      var fix = suggestEmail(email);
      if (fix && fix !== email && !typoOK) {
        input.value = fix;              /* pre-fill the fix so one more tap accepts it */
        typoOK = true;                  /* a second click sends whatever is in the box */
        input.classList.remove('err');
        input.removeAttribute('aria-invalid');
        errMsg.textContent = 'We corrected this to ' + fix + '. Tap again to confirm.';
        errMsg.classList.add('on');
        try { input.focus(); } catch (e) {}
        return;
      }
      input.classList.remove('err');
      input.removeAttribute('aria-invalid');
      errMsg.classList.remove('on');
      btn.disabled = true;
      btn.textContent = 'One moment…';

      subscribe(email, function (ok) {
        if (ok) {
          localStorage.setItem(KEY_DONE, '1');
          fade(renderSuccess);
        } else {
          btn.disabled = false;
          btn.textContent = 'Claim your 10% off';
          errMsg.textContent = 'Something went wrong, please try again.';
          errMsg.classList.add('on');
        }
      });
    });

    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') btn.click(); });
    if (!measuring) setTimeout(function () { input.focus(); }, 60);
  }

  function renderSuccess() {
    updateDots(2, true);
    inner.innerHTML = '';

    var tick = el('span', { className: 'pw-tick' });
    tick.innerHTML = ICON.check;
    inner.appendChild(tick);

    var h = el('h2', { className: 'pw-shead' });
    h.textContent = "You're in.";
    inner.appendChild(h);

    var s = el('p', { className: 'pw-ssub' });
    s.textContent = 'Use the code below on your first order. Your first email is on the way.';
    inner.appendChild(s);

    var box = el('div', { className: 'pw-codebox' });
    var code = el('span', { className: 'pw-code' });
    code.textContent = CODE;
    box.appendChild(code);

    var copyBtn = el('button', { type: 'button', className: 'pw-copy', 'aria-label': 'Copy code ' + CODE });
    copyBtn.innerHTML = ICON.copy + '<span>Copy</span>';
    copyBtn.addEventListener('click', function () {
      navigator.clipboard.writeText(CODE).then(function () {
        copyBtn.lastChild.textContent = 'Copied';
        setTimeout(function () { copyBtn.lastChild.textContent = 'Copy'; }, 2000);
      });
    });
    box.appendChild(copyBtn);
    inner.appendChild(box);

    /* 11-02: send each answer to its collection instead of /collections/all (the Welcome 1 quiz picks match) */
    var PICK = {
      classic: ['/collections/classic-natural-wine', 'See classic wines'],
      natural: ['/collections/natural-wine-from-around-the-world', 'See natural wines'],
      both:    ['/collections/best-sellers-natural-wine', 'See best sellers']
    }[answers.wine_style] || ['/collections/all', 'Start exploring'];
    var shop = el('a', { href: PICK[0], className: 'pw-shoplink' });
    shop.innerHTML = '<span>' + PICK[1] + '</span>' + ICON.arrow;
    inner.appendChild(shop);
    if (!measuring) focusFirst();
  }

  /* ── KLAVIYO SUBSCRIBE ──────────────────────────────────── */
  function subscribe(email, cb) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', 'https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY_ID, true);
    xhr.setRequestHeader('content-type', 'application/json');
    xhr.setRequestHeader('revision', '2025-10-15');
    xhr.timeout = 8000;
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4) return;
      cb(xhr.status < 300 || xhr.status === 409);
    };
    xhr.ontimeout = xhr.onerror = function () { cb(false); };
    xhr.send(JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: {
                  wine_style:         answers.wine_style || '',
                  drinking_occasion:  answers.drinking_occasion || ''
                }
              }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: LIST_ID } }
        }
      }
    }));
  }

  /* ── DISMISS ────────────────────────────────────────────── */
  function dismiss() {
    document.removeEventListener('keydown', onKeydown, true);
    setBackgroundInert(false);
    overlay.classList.remove('pw-on');
    localStorage.setItem(KEY_SEEN, Date.now().toString());
    setTimeout(function () {
      if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
    }, 300);
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  /* ── TRIGGER ────────────────────────────────────────────── */
  var fired = false;
  var focusWaits = 0;
  function launch() {
    if (fired) return;
    /* Never stack on the age gate. That gate is a modal dialog that owns focus
       and marks the rest of the page inert; opening this on top of it leaves a
       screen-reader or keyboard user trapped in a wine quiz while the site is
       still saying it needs their age. Wait it out instead. */
    var gate = document.getElementById('modal-popup-age-verification');
    if (gate && (gate.classList.contains('active') || !localStorage.getItem('modal-' + location.hostname + '-modal-popup-age-verification'))) {
      setTimeout(launch, 800);
      return;
    }
    /* Same for any other open modal: the cart, menu and filter drawers. Opening over one
       steals focus from the drawer the visitor is using (keyboard check KB-17). */
    if (document.querySelector('sidebar-drawer.sidebar--opened, [aria-modal="true"].active')) {
      setTimeout(launch, 2000);
      return;
    }
    /* Never take focus from a visitor who is in the middle of something. This dialog moves
       focus to its first control when it opens, so opening while a filter checkbox, a form
       field or a link they tabbed to holds focus throws a keyboard or screen-reader user out
       of their task. Wait for focus to be back on the page body, and give up after 8 tries
       (about 16 seconds) so the dialog never appears long after the visitor arrived. */
    var held = document.activeElement;
    if (held && held !== document.body && held !== document.documentElement) {
      if (++focusWaits > 8) return;
      setTimeout(launch, 2000);
      return;
    }
    fired = true;
    injectCSS();
    build();
  }

  var t = setTimeout(launch, TRIGGER_MS);

  if (pgCount >= TRIGGER_PGS) {
    clearTimeout(t);
    setTimeout(launch, 1200);
  }

  /* ── HELPERS ────────────────────────────────────────────── */
  function el(tag, attrs) {
    var node = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) { node.setAttribute(k === 'className' ? 'class' : k, attrs[k]); });
    return node;
  }
  function raf(fn) { requestAnimationFrame(fn); }

})();
